import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@voilajsx/uikit/card';
import { Button } from '@voilajsx/uikit/button';
import { AlertCircle, Edit } from 'lucide-react';
import { SEO } from '../../../../shared/components';

const EditGalleryPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEO
        title="Edit Gallery Item - Admin Panel"
        description="Edit gallery item details"
      />
      <div className="container mx-auto px-4 max-w-4xl py-8">
        <Card className="text-center p-8">
          <CardContent>
            <AlertCircle className="mx-auto h-12 w-12 text-gray-400 mb-4" />
            <h3 className="text-lg font-medium text-gray-700 mb-2">
              Gallery Item ID Required
            </h3>
            <p className="text-gray-500 mb-6">
              Please provide a gallery item ID to edit. Use the format: /gallery/admin/edit/[id]
            </p>
            <Button
              onClick={() => navigate('/gallery')}
              className="bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700"
            >
              <Edit className="mr-2 h-4 w-4" />
              Back to Gallery
            </Button>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default EditGalleryPage;
